<template>
  <v-app id="inspire">
    <v-app-bar app>
      <v-toolbar-title class="primary--text text-h4 font-weight-bold">
        <template v-if="$root.goBack">
          <inertia-link
            class="light-blue--text lighten-5--text"
            :href="route($root.goBack.url)"
          >
            {{ $root.goBack.title }}
          </inertia-link>
          /
        </template>
        {{ $root.appTitle }}
      </v-toolbar-title>
      <v-spacer />

      <v-img
        contain
        src="/img/logo_nwt_new.png"
        height="56px"
        max-width="200px"
      />
      <template #extension>
        <v-tabs align-with-title :value="activeTab">
          <v-tab v-for="(step, key) in $page.props.steps" :key="`step_${key}`" @click="$inertia.visit(route('questionnaire.create', [$page.props.token, step.step]))">
            {{ step.title }}
            <v-icon v-if="step.success" right>
              mdi-checkbox-marked-circle
            </v-icon>
            <v-icon v-else-if="step.error" right>
              mdi-alert-circle
            </v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <transition name="default">
      <v-main v-show="animate">
        <v-snackbar
          absolute
          top
          right
          color="primary"
          timeout="6000"
          :value="flash"
        >
          {{ $page.props.jetstream.flash }}

          <template #action="{ attrs }">
            <v-icon
              v-bind="attrs"
              @click="flashDismissed = true"
            >
              mdi-close
            </v-icon>
          </template>
        </v-snackbar>

        <slot />
      </v-main>
    </transition>
  </v-app>
</template>

<script>
export default {
   name: 'QuestionnaireLayout',
   data () {
      return {
         showUserMenu: false,
         accounts: null,
         animate: false,
         flashDismissed: false
      }
   },
   computed: {
      flash () {
         if (this.flashDismissed) {
            return false
         }

         return this.$page.props.jetstream.flash.length > 0
      },
      activeTab: function () {
         //  const url = new URL(window.location.href)
         const step = this.$page.props.steps.find(elem => elem.step.toString() === this.$page.props.step)
         return this.$page.props.steps.indexOf(step)
      }
   },
   mounted () {
      this.animate = true
      this.$inertia.on('start', (event) => {
         if (event.detail.visit.method === 'get') {
            this.animate = false
         }
      })

      this.$inertia.on('finish', (event) => {
         this.animate = true
      })
   },
   created () {

   },
   methods: {

   }
}
</script>
<style>

</style>
